var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "ticket-card p-4"
  }, [_c('div', {
    staticClass: "ticket-form"
  }, [_vm._m(0), _c('form', {
    ref: "ticketForm",
    on: {
      "submit": function ($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.submit.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 mb-3"
  }, [_c('input-text', {
    attrs: {
      "label": "Phone",
      "label-for": "phone",
      "vmodel": _vm.form.phone,
      "input-class": "shadow-none"
    },
    on: {
      "update:vmodel": function ($event) {
        return _vm.$set(_vm.form, "phone", $event);
      }
    }
  })], 1)]), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-12 col-sm-12 mb-3"
  }, [_c('input-text', {
    attrs: {
      "rules": {
        required: true
      },
      "label": "Subject",
      "label-for": "subject",
      "vmodel": _vm.form.subject,
      "input-class": "shadow-none",
      "vObject": _vm.$v.form.subject
    },
    on: {
      "update:vmodel": function ($event) {
        return _vm.$set(_vm.form, "subject", $event);
      }
    }
  })], 1), _c('div', {
    staticClass: "col-lg-6 col-md-12 col-sm-12 mb-3"
  }, [_c('b-form-group', {
    staticClass: "required",
    attrs: {
      "label": "Category",
      "label-for": "input-41",
      "invalid-feedback": "Category is required."
    }
  }, [_c('b-form-select', {
    attrs: {
      "id": "input-41",
      "options": _vm.optionCategories,
      "required": ""
    },
    model: {
      value: _vm.form.category_id,
      callback: function ($$v) {
        _vm.$set(_vm.form, "category_id", $$v);
      },
      expression: "form.category_id"
    }
  })], 1)], 1)]), _c('div', {
    staticClass: "form-group row"
  }, [_c('input-quill-editor', {
    attrs: {
      "vmodel": _vm.form.message,
      "label": "Message",
      "rules": {
        required: true
      },
      "placeholder": "Add your message here ...",
      "vObject": _vm.$v.form.message
    },
    on: {
      "update:vmodel": function ($event) {
        return _vm.$set(_vm.form, "message", $event);
      }
    }
  })], 1), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-12 mb-3"
  }, [_c('input-file-multiple', {
    attrs: {
      "label": "Upload Document",
      "validation-label": "document",
      "vmodel": _vm.form.issue_document,
      "vObject": _vm.$v.form.issue_document
    },
    on: {
      "update:vmodel": function ($event) {
        return _vm.$set(_vm.form, "issue_document", $event);
      }
    },
    scopedSlots: _vm._u([{
      key: "uploadedFiles",
      fn: function () {
        return [_c('span', {
          staticClass: "font-14 d-inline-block py-2 clr-lightgrey"
        }, [_vm._v("Allowed file types : jpeg,png,jpg,gif,svg,pdf,xls,xlsx,doc,docx,csv & txt")])];
      },
      proxy: true
    }])
  })], 1)]), _c('div', {
    staticClass: "form-group row justify-content-center"
  }, [_c('div', {
    staticClass: "col-lg-3 col-md-4"
  }, [_c('button', {
    staticClass: "ticket-submit-btn pull-right btn-no-focus",
    attrs: {
      "type": "submit"
    }
  }, [_vm.isSubmit ? _c('b-spinner', {
    staticClass: "custom-spin"
  }) : _vm._e(), _vm._v(_vm._s(_vm.isSubmit ? "Submitting ..." : "Submit") + " ")], 1)])])])])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "mb-3"
  }, [_c('h3', {
    staticClass: "main-text"
  }, [_vm._v("New Ticket")]), _c('span', {
    staticClass: "d-inline-bloc clr-bold-grey font-13"
  }, [_vm._v("Please fill the form below to submit your ticket.")])]);

}]

export { render, staticRenderFns }